import React from 'react';
import { compose } from 'redux';
import { ScreenName } from '@helpcenter/constants';
import { useIntl } from 'react-intl-next';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import {
    HelpCentersManagementPage,
    HelpCentersManagementResource,
    authPageMessage,
    callToActionUrlText,
} from '@atlassian/help-centers-management';

const HelpCentersManagement = () => {
    const { formatMessage } = useIntl();
    const WrappedComponent = React.useMemo(
        () =>
            compose(
                withOnlyLoggedIn({ redirectUrl: '/' }),
                withOnlyJiraAdmin({
                    message: formatMessage(authPageMessage),
                    callToActionText: formatMessage(callToActionUrlText),
                    callToActionUrl: '',
                })
            )(HelpCentersManagementPage),
        [formatMessage]
    );
    return <WrappedComponent />;
};

const HelpHubsManagement = () => {
    const { formatMessage } = useIntl();
    const WrappedComponent = React.useMemo(
        () =>
            compose(
                withOnlyLoggedIn({ redirectUrl: '/' }),
                withOnlyJiraAdmin({
                    message: formatMessage(authPageMessage),
                    callToActionText: formatMessage(callToActionUrlText),
                    callToActionUrl: '',
                })
            )(HelpCentersManagementPage),
        [formatMessage]
    );
    return <WrappedComponent />;
};
export const viewHelpCentersManagementPageRoute = {
    name: ScreenName.HELP_CENTERS_MANAGEMENT,
    path: '/',
    exact: true,
    component: HelpCentersManagement,
    resources: [HelpCentersManagementResource],
};

export const viewHelpHubsManagementPageRoute = {
    name: ScreenName.HELP_HUBS_MANAGEMENT,
    path: '/hubs',
    exact: true,
    component: HelpHubsManagement,
    resources: [HelpCentersManagementResource],
};
